import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { IconButton } from '@material-ui/core';
import { Edit, Delete } from 'react-feather';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function SimpleTable(props) {
    const {requestDetails, handleDelete, handleEdit} = props;
    const classes = useStyles();

  return (
    <Paper>
      <div className="table-responsive">
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Найменування суб'єкту, у якому буде застосовано МШ</TableCell>
            <TableCell>Прізвище  уповноваженої особи</TableCell>
            <TableCell>Ім'я  уповноваженої особи </TableCell>
            <TableCell>По батькові  уповноваженої особи </TableCell>
            <TableCell>Контактний телефон </TableCell>
            <TableCell>Адреса електронної пошти  </TableCell>
            <TableCell>Функції</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requestDetails.map((row, index) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.merchantName}
              </TableCell>
              <TableCell align="right">{row.agentSurname}</TableCell>
              <TableCell align="right">{row.agentName}</TableCell>
              <TableCell align="right">{row.agentPatronymic}</TableCell>
              <TableCell align="right">{row.phone}</TableCell>
              <TableCell align="right">{row.email}</TableCell>
              <TableCell align="right">
                  <IconButton onClick={() => handleEdit(index)}>
                      <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(index)}>
                      <Delete />
                  </IconButton>
            </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </div>
    </Paper>
  );
}